import {Component} from '@angular/core';
import * as am5 from '@amcharts/amcharts5';
import {DashboardBaseComponent} from './dashboard-base-component';

@Component({
  selector: 'chart-base-dashboard',
  template: '',
})
export abstract class DashboardBaseChart extends DashboardBaseComponent {
  protected root!: am5.Root;

  private originalResolution?: number;

  protected abstract initChart(): void;

  public abstract load(data: any[] | any): void;

  configurePdfExport(): void {
    if (!this.root) return;
    //sube la resolución interna del chart antes de capturar y la bajan después en resetPageAfterExport
    this.originalResolution = this.root._renderer.resolution;
    this.root._renderer.resolution = 2;
    this.root.resize();
  }

  resetPageAfterExport(): void {
    if (!this.root || this.originalResolution == null) return;
    this.root._renderer.resolution = this.originalResolution;
    this.root.resize();
  }



}
